const config = {
    build_number: '602901',
    build_timestamp: '2025-07-07T15:46:58.316Z',
    build_commit: '376262bdb6e8456f0c20a7f1599215a78fe580ad',
};

// locally, the build number is always 4122 (which allows us to load non-English content locally)
if (Number.isNaN(parseInt(config.build_number, 10))) {
    config.build_number = '4122';
}

export default config;
